import React, { useState } from 'react';
import { push, ref, set, update } from 'firebase/database';
import { database } from '../firebaseConfig';
import { saveMarketingLink } from '../services/marketingLinks';

// Feature and upgrade list, all in Resi:
// 1. Marketing manager pastes the link to the list on "Create Feature and Upgrade List" and presses Done.
//    That finishes her part. It does not come back to her.
// 2. "Review and Print Feature and Upgrade List" appears for the agent, with the link. The agent prints it.

const nowIso = () => new Date().toISOString();
const todayDate = () => new Date().toISOString().slice(0, 10);

const isCreate = (name) => /^create feature and upgrade list$/i.test((name || '').trim());
const isPrint = (name) => /^review and print feature and upgrade list$/i.test((name || '').trim());
export const isFeatureUpgradeTask = (name) => isCreate(name) || isPrint(name);

const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' };
const btnOff = { ...btn, background: '#FFFFFF', color: '#B8962E', borderColor: '#D5D9E0', opacity: 0.5, cursor: 'not-allowed' };
const input = { flex: '1 1 260px', padding: '8px 10px', borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 13, minWidth: 200 };

export default function FeatureUpgradeFlow({ task, txId }) {
  const taskName = task.name || task.title || '';
  const [link, setLink] = useState(task.featureUpgradeLink || '');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (!txId || !isFeatureUpgradeTask(taskName)) return null;

  // Marketing manager: save the link, finish her task, and create the agent's print task.
  const done = async () => {
    const value = link.trim();
    if (!/^https?:\/\//i.test(value)) { setError('Paste the full link, starting with https://'); return; }
    setBusy(true); setError('');
    try {
      await update(ref(database, `transactions/${txId}/tasks/${task.id}`), { featureUpgradeLink: value, status: 'completed', completedAt: nowIso() });
      await saveMarketingLink(txId, 'featureUpgrade', 'Feature and upgrade list', value);
      await set(push(ref(database, `transactions/${txId}/tasks`)), {
        name: 'Review and Print Feature and Upgrade List',
        role: 'Agent',
        type: 'Task',
        appliesTo: 'All',
        anchor: null,
        offsetDays: 0,
        shared: false,
        action: null,
        mode: 'task',
        dueDate: todayDate(),
        status: 'pending',
        completedBy: null,
        completedAt: null,
        createdBy: null,
        createdAt: nowIso(),
        featureUpgradeLink: value,
      });
    } catch (err) {
      console.error('Could not send feature and upgrade list to agent', err);
      setError('Could not save. Please try again.');
    } finally { setBusy(false); }
  };

  if (isCreate(taskName)) {
    const ok = /^https?:\/\//i.test(link.trim());
    return (
      <div style={{ margin: '6px 0' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
          <input value={link} onChange={(e) => setLink(e.target.value)} placeholder="Paste the feature and upgrade list link (https://...)" style={input} />
          <button type="button" onClick={done} disabled={!ok || busy} style={ok && !busy ? btn : btnOff}>Done</button>
        </div>
        {error && <div style={{ color: '#b00020', fontSize: 12, marginTop: 4 }}>{error}</div>}
      </div>
    );
  }

  // Agent: the link to review and print.
  return (
    <div style={{ margin: '6px 0', fontSize: 13 }}>
      {task.featureUpgradeLink && <div><a href={task.featureUpgradeLink} target="_blank" rel="noreferrer" style={{ color: '#8C6D1F', fontWeight: 600 }}>Open feature and upgrade list to review and print</a></div>}
    </div>
  );
}
